import '../../../scss/pages/buying-online/main.scss';
import '../../../scss/pages/vendor-legal/main.scss';
import onDomContentLoaded from '../../utilities/onDomContentLoaded';
import { VENDOR_ENTRY_ID } from '../../api/content-service-api';
import contentfulStartup from '../../utilities/contentful/contentfulStartup';

onDomContentLoaded(() => contentfulStartup({ containerId: 'vendor-legal--container', entryId: VENDOR_ENTRY_ID }));
